import React from 'react'
import { CSSTransition } from 'react-transition-group'
import { ErrorPopup } from './ErrorPopup'
import './ErrorPopup.css'

interface ErrorDetails {
  message: string
  isVisible: boolean
}

interface MultiErrorPopupProps {
  errors: { [key: string]: ErrorDetails }
  removeError: (id: string) => void
  timeout?: number
}

export const MultiErrorPopup: React.FC<MultiErrorPopupProps> = ({
  errors,
  removeError,
  timeout = 1000, // default value set here
}) => {
  return (
    <div className="error-popup-container">
      {Object.entries(errors).map(([id, { message, isVisible }]) => (
        <CSSTransition key={id} in={isVisible} timeout={timeout}>
          <ErrorPopup message={message} removeError={() => removeError(id)} />
        </CSSTransition>
      ))}
    </div>
  )
}
